__webpack_require__.p = "/hotel/";